import React, { useState } from 'react';
import PropTypes from 'prop-types';

const PasswordInput = ({ 
  label, 
  id, 
  placeholder, 
  value, 
  onChange, 
  required = false,
  error,
  className = '',
  ...props 
}) => {
  const [showPassword, setShowPassword] = useState(false);
  
  const inputClass = `form-input ${error ? 'form-input-error' : ''} ${className}`.trim();
  
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      togglePasswordVisibility();
    }
  };
  
  return (
    <div className="form-group ">
      {label && (
        <label htmlFor={id} className="form-label">
          {label}
        </label>
      )}
      <div className="password-input-container">
        <input
          id={id}
          name={id}
          type={showPassword ? "text" : "password"}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          required={required}
          className={inputClass}
          aria-describedby={`${id}-toggle`}
          {...props}
        />
        <button
          type="button"
          className="password-toggle"
          onClick={togglePasswordVisibility}
          onKeyDown={handleKeyDown}
          aria-label={showPassword ? "Hide password" : "Show password"}
          aria-pressed={showPassword}
          aria-describedby={`${id}-toggle-tooltip`}
        >
          {!showPassword ? (
            <svg 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2"
              aria-hidden="true"
              focusable="false"
            >
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
              <circle cx="12" cy="12" r="3"/>
              <path d="M3 3l18 18"/>
            </svg>
          ) : (
            <svg 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2"
              aria-hidden="true"
              focusable="false"
            >
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
              <circle cx="12" cy="12" r="3"/>
            </svg>
          )}
          <span id={`${id}-toggle-tooltip`} className="sr-only">
            {showPassword ? "Press Enter or Space to hide password" : "Press Enter or Space to show password"}
          </span>
        </button>
      </div>
      {error && <span className="form-error">{error}</span>}
    </div>
  );
};

PasswordInput.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  required: PropTypes.bool,
  error: PropTypes.string,
  className: PropTypes.string
};

export default PasswordInput;
